import type { RangeValue } from '@shared/types';

export type RangeParseResult = {
  type: 'range';
  value: RangeValue;
};

/**
 * Detects range syntax inside a `[...]` array literal: `[start:end]` or
 * `[start:step:end]` — colons present, no commas.
 *
 * Called only when valueStr starts with `[` and ends with `]` and we have not
 * already detected polygonpad.
 *
 * Returns null if the content does not match the range pattern.
 */
export function parseRangeType(valueStr: string): RangeParseResult | null {
  const content = valueStr.slice(1, -1).trim();

  if (!content.includes(':') || content.includes(',')) return null;

  const parts = content.split(':').map((s) => s.trim());
  const numParts = parts.map(Number);

  if (numParts.some(isNaN)) return null;

  if (parts.length === 2) {
    return {
      type: 'range',
      value: { start: numParts[0], end: numParts[1], step: null },
    };
  }

  if (parts.length === 3) {
    return {
      type: 'range',
      value: { start: numParts[0], step: numParts[1], end: numParts[2] },
    };
  }

  return null;
}
